/* Ruleta FUSFIT Day (13-nov-2026) — sin dependencias, ES2017.
   - Solo actúa con <html class="ff-fd-dia"> (y vigila la clase por si cambia de fase con la página abierta).
   - El ERP decide el premio: la rueda solo anima hasta el `sector` que devuelve. El código ganado se aplica al
     carrito de este navegador (/cart/update.js {discount}; si no queda, /discount/CODIGO) y se muestra en pantalla.
     El WhatsApp solo se registra en el ERP. Nunca se muestra inventario.
   - «Ya está aplicado» solo si /cart.js trae el código con applicable !== false; si no, «Guardado» (carrito vacío)
     o «Escríbelo al pagar».
   - Todo acceso a localStorage/sessionStorage va en try/catch: sin almacenamiento funciona igual (id en memoria). */
(function () {
  'use strict';
  var raiz = document.getElementById('ff-ruleta');
  if (!raiz || window.__ffRuleta) return;
  window.__ffRuleta = true;
  var ERP = raiz.getAttribute('data-erp');
  var html = document.documentElement;
  var NS = 'http://www.w3.org/2000/svg';
  var K_ID = 'ff_ruleta_id', K_ABIERTA = 'ff_ruleta_abierta', K_REABIERTA = 'ff_ruleta_reabierta', K_RES = 'ff_ruleta_res';
  var S_ESTADO = 'ff_ruleta_estado', S_REAPLICADO = 'ff_ruleta_reaplicado'; // sessionStorage
  var REABRIR_MS = 30 * 60000, ESPERA_MS = 1500, CACHE_GET_MS = 5 * 60000, CARRITO_MS = 8000;
  var memoria = {};
  var reducir = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function leer(k) { try { var v = window.localStorage.getItem(k); return v == null ? null : v; } catch (e) { return null; } }
  function guardar(k, v) { try { window.localStorage.setItem(k, v); return true; } catch (e) { return false; } }
  function leerS(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function guardarS(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* sin sesión: sin caché */ } }
  function idNavegador() {
    var id = leer(K_ID) || memoria.id;
    if (id && /^[A-Za-z0-9-]{16,64}$/.test(id)) return id;
    if (window.crypto && crypto.randomUUID) id = crypto.randomUUID();
    else {
      var b = new Uint8Array(16); crypto.getRandomValues(b);
      id = Array.prototype.map.call(b, function (x) { return (x < 16 ? '0' : '') + x.toString(16); }).join('');
    }
    memoria.id = id; guardar(K_ID, id);
    return id;
  }
  function resGuardado() {
    try { var r = JSON.parse(leer(K_RES) || 'null'); return r && typeof r.titulo === 'string' ? r : null; } catch (e) { return null; }
  }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function sv(tag, at) { var e = document.createElementNS(NS, tag); for (var k in at) e.setAttribute(k, at[k]); return e; }

  var estado = null;         // { sectores: [...] }
  var ui = null;             // nodos del modal
  var abierto = false, girando = false, angulo = 0, ultimoFoco = null, iniciado = false, overflowPrevio = '';

  /* ---------- Rueda SVG ---------- */
  function lineas(txt) {
    txt = String(txt).trim();
    if (txt.length <= 13) return [txt];
    var p = txt.split(/\s+/), mejor = [txt], peor = Infinity;
    for (var i = 1; i < p.length; i++) {
      var a = p.slice(0, i).join(' '), b = p.slice(i).join(' '), m = Math.max(a.length, b.length);
      if (m < peor) { peor = m; mejor = [a, b]; }
    }
    return mejor;
  }
  function rueda(sectores) {
    var n = sectores.length, paso = 360 / n, R = 190;
    var svg = sv('svg', { viewBox: '-200 -200 400 400', class: 'ff-rl-svg', 'aria-hidden': 'true', focusable: 'false' });
    var g = sv('g', {});
    function pt(ang, r) { var a = (ang - 90) * Math.PI / 180; return [r * Math.cos(a), r * Math.sin(a)]; }
    sectores.forEach(function (s, i) {
      var a0 = i * paso - paso / 2, a1 = i * paso + paso / 2, p0 = pt(a0, R), p1 = pt(a1, R);
      var d = n === 1 ? 'M0 ' + -R + 'A' + R + ' ' + R + ' 0 1 1 0 ' + R + 'A' + R + ' ' + R + ' 0 1 1 0 ' + -R + 'Z'
        : 'M0 0L' + p0[0].toFixed(2) + ' ' + p0[1].toFixed(2) + 'A' + R + ' ' + R + ' 0 ' + (paso > 180 ? 1 : 0) + ' 1 ' + p1[0].toFixed(2) + ' ' + p1[1].toFixed(2) + 'Z';
      g.appendChild(sv('path', { d: d, fill: s.color, class: 'ff-rl-sector' }));
      var ls = lineas(s.etiqueta), largo = Math.max.apply(null, ls.map(function (x) { return x.length; }));
      var fs = Math.max(10, Math.min(n > 8 ? 22 : 30, 118 / (largo * 0.56)));
      var ang = i * paso, voltear = ang > 180 && ang < 360; // en la mitad izquierda se voltea para que no quede de cabeza
      var t = sv('text', { transform: voltear ? 'rotate(' + (ang + 90) + ') translate(-118 0)' : 'rotate(' + (ang - 90) + ') translate(118 0)', 'text-anchor': 'middle', 'dominant-baseline': 'central',
        fill: s.texto || '#ffffff', 'font-size': fs.toFixed(1), class: 'ff-rl-et' + ((s.texto || '').toLowerCase() === '#ffffff' ? ' ff-rl-et--claro' : '') });
      ls.forEach(function (x, k) {
        var sp = sv('tspan', { x: 0, dy: k === 0 ? (ls.length > 1 ? -fs * 0.55 : 0) : fs * 1.1 });
        sp.textContent = x; t.appendChild(sp);
      });
      g.appendChild(t);
    });
    // Bombillos de feria en el borde, uno en cada separación y uno en medio de cada sector.
    var bombillos = sv('g', { class: 'ff-rl-bombillos' });
    for (var b = 0; b < n * 2; b++) {
      var q = pt(b * paso / 2 - paso / 2, R - 9);
      bombillos.appendChild(sv('circle', { cx: q[0].toFixed(2), cy: q[1].toFixed(2), r: 4.6, class: 'ff-rl-bombillo' + (b % 2 ? ' ff-rl-bombillo--b' : '') }));
    }
    g.appendChild(bombillos);
    svg.appendChild(g);
    return svg;
  }
  function centro() {
    var svg = sv('svg', { viewBox: '-40 -40 80 80', class: 'ff-rl-centro', 'aria-hidden': 'true', focusable: 'false' });
    svg.appendChild(sv('circle', { r: 37, fill: '#ffffff' }));
    svg.appendChild(sv('circle', { r: 30, fill: '#D7FF1F' }));
    svg.appendChild(sv('path', { d: 'M5-21L-13 4h12l-5 18 19-27H1z', fill: '#1a1a1a' }));
    return svg;
  }

  /* ---------- Modal ---------- */
  function construir() {
    var fondo = el('div', 'ff-rl-fondo'); fondo.hidden = true;
    var dlg = el('div', 'ff-rl-modal');
    dlg.setAttribute('role', 'dialog'); dlg.setAttribute('aria-modal', 'true'); dlg.setAttribute('aria-labelledby', 'ff-rl-titulo');
    dlg.setAttribute('aria-describedby', 'ff-rl-sub');
    var cerrar = el('button', 'ff-rl-x'); cerrar.type = 'button'; cerrar.setAttribute('aria-label', 'Cerrar la ruleta');
    cerrar.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg>';

    var zonaRueda = el('div', 'ff-rl-zona');
    var marco = el('div', 'ff-rl-marco');
    var giro = el('div', 'ff-rl-giro'); giro.appendChild(rueda(estado.sectores));
    marco.appendChild(giro); marco.appendChild(centro());
    var puntero = el('div', 'ff-rl-puntero'); puntero.setAttribute('aria-hidden', 'true');
    marco.appendChild(puntero);
    zonaRueda.appendChild(marco);

    var lado = el('div', 'ff-rl-lado');
    var tit = el('h2', 'ff-rl-titulo', '¡Gira y gana!'); tit.id = 'ff-rl-titulo';
    var sub = el('p', 'ff-rl-sub', 'Hoy es FUSFIT Day y todos ganan. Escribe tu WhatsApp, gira la ruleta y tu premio queda aplicado en tu carrito.'); sub.id = 'ff-rl-sub';

    var form = el('form', 'ff-rl-form'); form.noValidate = true;
    var lab = el('label', 'ff-rl-lab', 'Tu WhatsApp'); lab.htmlFor = 'ff-rl-tel';
    var inp = el('input', 'ff-rl-tel'); inp.id = 'ff-rl-tel'; inp.type = 'tel'; inp.name = 'telefono';
    inp.setAttribute('inputmode', 'tel'); inp.setAttribute('autocomplete', 'tel'); inp.setAttribute('aria-describedby', 'ff-rl-ayuda ff-rl-error');
    inp.maxLength = 24;
    var ayuda = el('p', 'ff-rl-ayuda', 'Lo usamos para avisarte de próximas ofertas. Ej.: 0414 123 4567 o +58 414 123 4567'); ayuda.id = 'ff-rl-ayuda';
    var err = el('p', 'ff-rl-error'); err.id = 'ff-rl-error'; err.setAttribute('aria-live', 'assertive');
    var btn = el('button', 'ff-rl-btn', '¡Girar!'); btn.type = 'submit';
    form.appendChild(lab); form.appendChild(inp); form.appendChild(ayuda); form.appendChild(err); form.appendChild(btn);

    var res = el('div', 'ff-rl-res'); res.hidden = true; res.setAttribute('aria-live', 'polite');
    var resTit = el('p', 'ff-rl-res-tit'), resTxt = el('p', 'ff-rl-res-txt'), resNota = el('p', 'ff-rl-res-nota');
    var seguir = el('button', 'ff-rl-btn ff-rl-btn--seguir', 'Seguir comprando'); seguir.type = 'button';
    var cod = el('div', 'ff-rl-cod'); cod.hidden = true;
    var codEstado = el('p', 'ff-rl-cod-estado');
    var codFila = el('div', 'ff-rl-cod-fila');
    var codTxt = el('span', 'ff-rl-cod-txt');
    var copiar = el('button', 'ff-rl-copiar', 'Copiar'); copiar.type = 'button'; copiar.setAttribute('aria-label', 'Copiar el código');
    var copiado = el('span', 'ff-rl-copiado'); copiado.setAttribute('aria-live', 'polite');
    codFila.appendChild(codTxt); codFila.appendChild(copiar);
    cod.appendChild(codEstado); cod.appendChild(codFila); cod.appendChild(copiado);
    res.appendChild(resTit); res.appendChild(resTxt); res.appendChild(cod); res.appendChild(resNota); res.appendChild(seguir);

    lado.appendChild(tit); lado.appendChild(sub); lado.appendChild(form); lado.appendChild(res);
    dlg.appendChild(cerrar); dlg.appendChild(zonaRueda); dlg.appendChild(lado);
    fondo.appendChild(dlg);
    raiz.appendChild(fondo);

    var flot = el('button', 'ff-rl-flotante'); flot.type = 'button'; flot.hidden = true;
    var hueco = document.getElementById('ff-fd-flotante'); // sitio reservado por la decoración (abajo a la izquierda)
    (hueco || raiz).appendChild(flot);
    if (!hueco) flot.classList.add('ff-rl-flotante--propio');

    ui = { fondo: fondo, dlg: dlg, cerrar: cerrar, giro: giro, form: form, inp: inp, err: err, btn: btn, sub: sub,
      res: res, resTit: resTit, resTxt: resTxt, resNota: resNota, seguir: seguir, flot: flot, tit: tit,
      cod: cod, codEstado: codEstado, codTxt: codTxt, copiar: copiar, copiado: copiado };

    cerrar.addEventListener('click', cerrarModal);
    seguir.addEventListener('click', cerrarModal);
    fondo.addEventListener('mousedown', function (e) { if (e.target === fondo) cerrarModal(); });
    flot.addEventListener('click', abrirModal);
    document.addEventListener('keydown', teclado); // en document: Esc y Tab funcionan aunque el foco caiga en <body>
    copiar.addEventListener('click', copiarCodigo);
    form.addEventListener('submit', enviar);
    inp.addEventListener('input', function () { if (ui.err.textContent) { ui.err.textContent = ''; ui.inp.removeAttribute('aria-invalid'); } });
  }

  function textoFlotante() {
    ui.flot.textContent = resGuardado() || memoria.res ? '🎁 Tu premio' : '🎡 Gira la ruleta';
  }
  function enfocables() {
    return Array.prototype.filter.call(ui.dlg.querySelectorAll('button, input, [href], [tabindex]:not([tabindex="-1"])'),
      function (e) { return !e.disabled && e.offsetParent !== null; });
  }
  function teclado(e) {
    if (!abierto) return;
    if (e.key === 'Escape') { e.preventDefault(); cerrarModal(); return; }
    if (e.key !== 'Tab') return;
    var f = enfocables(); if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (!ui.dlg.contains(document.activeElement)) { e.preventDefault(); (e.shiftKey ? z : a).focus(); return; }
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }
  function abrirModal() {
    if (abierto || !ui) return;
    abierto = true;
    ultimoFoco = document.activeElement;
    ui.flot.hidden = true;
    var r = memoria.res || resGuardado();
    if (r) { memoria.res = r; mostrarResultado(r, false); revisarCarrito(r); }
    ui.fondo.hidden = false;
    overflowPrevio = html.style.overflow;
    html.style.overflow = 'hidden';
    requestAnimationFrame(function () { ui.fondo.classList.add('is-on'); });
    (r ? ui.seguir : ui.inp).focus({ preventScroll: true });
  }
  function cerrarModal() {
    if (!abierto || girando) return;
    abierto = false;
    ui.fondo.classList.remove('is-on');
    ui.fondo.hidden = true;
    html.style.overflow = overflowPrevio;
    if (memoria.apagada) {
      ui.flot.hidden = true;
      if (ultimoFoco && ultimoFoco.focus && document.contains(ultimoFoco)) ultimoFoco.focus({ preventScroll: true });
      return;
    }
    textoFlotante();
    ui.flot.hidden = false;
    ui.flot.focus({ preventScroll: true });
  }

  /* ---------- Giro ---------- */
  function validarLigero(t) {
    var s = String(t || '').trim();
    if (!/^\+?[\d\s().-]+$/.test(s)) return false;
    var d = s.replace(/\D/g, '');
    if (s.charAt(0) === '+') return d.length >= 8 && d.length <= 15 && d.charAt(0) !== '0';
    return /^(0?4\d{9}|58 ?4\d{9})$/.test(d);
  }
  function error(msg) {
    ui.err.textContent = msg;
    ui.inp.setAttribute('aria-invalid', 'true');
    ui.inp.focus({ preventScroll: true });
  }
  var preGiro = 0;
  function empezarPreGiro() {
    if (reducir.matches) return;
    var t0 = null;
    function paso(t) {
      if (!preGiro) return;
      if (t0 != null) { angulo += (t - t0) * 0.36; ui.giro.style.transform = 'rotate(' + angulo + 'deg)'; }
      t0 = t; preGiro = requestAnimationFrame(paso);
    }
    ui.giro.style.transition = 'none';
    preGiro = requestAnimationFrame(paso);
  }
  function pararPreGiro() { if (preGiro) cancelAnimationFrame(preGiro); preGiro = 0; }
  function indiceSector(id) {
    for (var i = 0; i < estado.sectores.length; i++) if (estado.sectores[i].id === id) return i;
    return -1;
  }
  function girarHasta(idSector, listo) {
    var s = estado.sectores, n = s.length, paso = 360 / n, k = indiceSector(idSector);
    var jitter = (Math.random() - 0.5) * paso * 0.6;
    var destino = ((-k * paso + jitter) % 360 + 360) % 360;         // ángulo (mod 360) que deja el sector bajo el puntero
    var actual = ((angulo % 360) + 360) % 360;
    var delta = (destino - actual + 360) % 360;
    var rapido = reducir.matches;
    if (!rapido) delta += 360 * (4 + Math.floor(Math.random() * 3)); // 4–6 vueltas
    var dur = rapido ? 500 : 4500;
    angulo += delta;
    ui.giro.style.transition = 'none';
    void ui.giro.offsetWidth;
    ui.giro.style.transition = 'transform ' + dur + 'ms ' + (rapido ? 'ease-out' : 'cubic-bezier(.15,.75,.2,1)');
    ui.giro.style.transform = 'rotate(' + angulo + 'deg)';
    raiz.classList.add('ff-rl-girando');
    var hecho = false;
    function fin() { if (hecho) return; hecho = true; raiz.classList.remove('ff-rl-girando'); listo(); }
    ui.giro.addEventListener('transitionend', fin, { once: true });
    setTimeout(fin, dur + 200);
  }
  function mostrarResultado(r, nuevo) {
    ui.form.hidden = true;
    ui.sub.hidden = true;
    ui.tit.textContent = r.ya ? '¡Ya giraste!' : '¡Felicidades!';
    ui.resTit.textContent = r.titulo;
    ui.resTxt.textContent = r.texto || '';
    pintarCodigo(r);
    ui.res.hidden = false;
    ui.dlg.classList.add('is-res');
    // La rueda queda marcando el premio (sin animar) si se abre de nuevo.
    if (!nuevo && r.sector != null && !girando) {
      var s = estado.sectores, paso = 360 / s.length;
      for (var i = 0; i < s.length; i++) if (s[i].id === r.sector) { angulo = -i * paso; ui.giro.style.transition = 'none'; ui.giro.style.transform = 'rotate(' + angulo + 'deg)'; }
    }
  }
  function enviar(e) {
    e.preventDefault();
    if (girando) return;
    var tel = ui.inp.value;
    if (!validarLigero(tel)) { error('Revisa tu número de WhatsApp.'); return; }
    ui.err.textContent = ''; ui.inp.removeAttribute('aria-invalid');
    girando = true;
    ui.btn.disabled = true; ui.inp.readOnly = true; ui.btn.textContent = 'Girando…';
    ui.cerrar.disabled = true;
    empezarPreGiro();
    function soltar() { girando = false; ui.btn.disabled = false; ui.inp.readOnly = false; ui.btn.textContent = '¡Girar!'; ui.cerrar.disabled = false; }
    function volverAlReposo() { pararPreGiro(); }
    var ac = window.AbortController ? new AbortController() : null;
    var reloj = ac ? setTimeout(function () { ac.abort(); }, 12000) : 0; // sin respuesta en 12 s → error en línea
    fetch(ERP, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit', cache: 'no-store',
      signal: ac ? ac.signal : undefined, body: JSON.stringify({ navegador: idNavegador(), telefono: String(tel).trim() }) })
      .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
      .then(function (j) {
        clearTimeout(reloj);
        pararPreGiro();
        if (j && j.ok && (j.resultado === 'premio' || j.resultado === 'ya') && indiceSector(j.sector) >= 0 && /^[A-Za-z0-9_-]{4,40}$/.test(j.codigo || '')) {
          var r = { titulo: String(j.titulo || ''), texto: String(j.texto || ''), sector: j.sector, ya: j.resultado === 'ya',
            codigo: String(j.codigo), premio: String(j.premio || ''), variante: typeof j.variante_regalo === 'number' ? j.variante_regalo : null };
          guardarRes(r);
          var carrito = aplicarEnCarrito(r); // en paralelo con la animación
          if (r.ya) { carrito.then(function () { soltar(); mostrarResultado(r, false); ui.seguir.focus({ preventScroll: true }); }); return; }
          girarHasta(j.sector, function () {
            carrito.then(function () { soltar(); mostrarResultado(r, true); ui.seguir.focus({ preventScroll: true }); confeti(); });
          });
          return;
        }
        soltar();
        if (j && j.ok && j.resultado === 'ya_numero') { error(String(j.mensaje || 'Este número ya giró la ruleta.')); return; }
        if (j && j.ok && j.resultado === 'apagada') {
          memoria.apagada = true;
          ui.form.hidden = true;
          ui.sub.textContent = 'La ruleta ya no está disponible. ¡Gracias por pasar por el FUSFIT Day!';
          ui.cerrar.focus({ preventScroll: true });
          return;
        }
        error((j && j.error) || 'No se pudo completar. Prueba de nuevo en un rato.');
      })
      .catch(function () { clearTimeout(reloj); volverAlReposo(); soltar(); error('No hay conexión. Prueba de nuevo en un momento.'); });
  }

  /* ---------- Carrito: el código ganado (y el regalo) quedan aplicados ---------- */
  var RAIZ_T = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function guardarRes(r) { memoria.res = r; guardar(K_RES, JSON.stringify(r)); }
  /** fetch al carrito con tope de 8 s: nunca deja la ruleta colgada en «Girando…». */
  function fetchCarrito(url, op) {
    var ac = window.AbortController ? new AbortController() : null;
    var reloj = ac ? setTimeout(function () { ac.abort(); }, CARRITO_MS) : 0;
    op.signal = ac ? ac.signal : undefined;
    return fetch(url, op).then(function (x) { clearTimeout(reloj); return x; }, function (e) { clearTimeout(reloj); throw e; });
  }
  function cartJs() { return fetchCarrito(RAIZ_T + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (x) { return x.json(); }); }
  function cartPost(ruta, cuerpo) {
    return fetchCarrito(RAIZ_T + ruta, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(cuerpo) })
      .then(function (x) { if (!x.ok) throw new Error('carrito ' + x.status); return x.json(); });
  }
  function codigoEn(c, cod) {
    var l = c.discount_codes || [];
    for (var i = 0; i < l.length; i++) if (String(l[i].code).toUpperCase() === cod.toUpperCase()) return l[i];
    return null;
  }
  function tieneCodigo(c, cod) { return !!codigoEn(c, cod); }
  /** Estado REAL del código en el carrito: 'aplicado' | 'guardado' (carrito vacío) | 'no'; y si hay otro código. */
  function leerEstadoCarrito(r, c) {
    var d = codigoEn(c, r.codigo);
    r.otroCodigo = (c.discount_codes || []).some(function (x) { return String(x.code).toUpperCase() !== r.codigo.toUpperCase(); });
    if (d && d.applicable !== false) r.estadoCarrito = 'aplicado';
    else if (d && !c.item_count) r.estadoCarrito = 'guardado';
    else r.estadoCarrito = 'no';
  }
  function avisarTema(c) { // el contador del carrito del tema escucha 'cart:update'
    try {
      var ev = new Event('cart:update', { bubbles: true });
      ev.detail = { resource: c, sourceId: 'ff-ruleta', data: { source: 'ff-ruleta', itemCount: c.item_count } };
      document.dispatchEvent(ev);
    } catch (e) { /* sin aviso, el tema lo verá al recargar */ }
  }
  /** Promesa que nunca falla: deja r.estadoCarrito, r.otroCodigo y r.regaloPuesto. */
  function aplicarEnCarrito(r) {
    var paso = Promise.resolve(), cambio = false;
    if (r.premio === 'producto' && r.variante && !r.regaloPuesto) {
      paso = cartJs().then(function (c) {
        if ((c.items || []).some(function (i) { return i.variant_id === r.variante; })) return null;
        cambio = true;
        return cartPost('cart/add.js', { items: [{ id: r.variante, quantity: 1 }] });
      }).then(function () { r.regaloPuesto = true; guardarRes(r); }).catch(function () { /* sin regalo en el carrito: se explica en pantalla */ });
    }
    return paso.then(cartJs).then(function (c) {
      if (tieneCodigo(c, r.codigo)) return c;
      // Se conservan los códigos que ya tuviera (p. ej. de una afiliada): Shopify acepta varios separados por coma.
      var otros = (c.discount_codes || []).map(function (d) { return String(d.code); })
        .filter(function (x) { return x.toUpperCase() !== r.codigo.toUpperCase(); });
      cambio = true;
      return cartPost('cart/update.js', { discount: otros.concat(r.codigo).join(',') });
    }).then(function (c) {
      if (tieneCodigo(c, r.codigo)) return c;
      return fetchCarrito(RAIZ_T + 'discount/' + encodeURIComponent(r.codigo), { credentials: 'same-origin' }).then(cartJs);
    }).then(function (c) {
      leerEstadoCarrito(r, c);
      guardarRes(r);
      if (cambio) avisarTema(c);
      return r;
    }).catch(function () { r.estadoCarrito = 'no'; r.otroCodigo = false; return r; });
  }
  /** Solo lectura: al reabrir «Tu premio» el estado se pinta como está HOY en el carrito. */
  function revisarCarrito(r) {
    if (!r.codigo) return;
    cartJs().then(function (c) {
      leerEstadoCarrito(r, c); guardarRes(r);
      if (abierto && (memoria.res === r)) pintarCodigo(r);
    }).catch(function () { /* se queda el último estado conocido */ });
  }
  function pintarCodigo(r) {
    ui.copiado.textContent = '';
    if (!r.codigo) { ui.cod.hidden = true; ui.resNota.textContent = ''; return; }
    ui.codTxt.textContent = r.codigo;
    ui.codEstado.classList.toggle('is-aplicado', r.estadoCarrito === 'aplicado'); // el ✓ solo si de verdad está aplicado
    ui.codEstado.textContent = r.estadoCarrito === 'aplicado' ? 'Ya está aplicado en tu carrito'
      : r.estadoCarrito === 'guardado' ? 'Guardado: se aplica al agregar productos' : 'Escríbelo al pagar';
    ui.cod.hidden = false;
    var notas = [];
    var choque = r.estadoCarrito === 'no' && r.otroCodigo;
    ui.resNota.classList.toggle('is-aviso', choque);
    if (choque) notas.push('Tu carrito ya tiene otro código; el de la ruleta no se suma con códigos de afiliadas. Elige uno al pagar.');
    if (r.premio === 'producto') notas.push(r.regaloPuesto ? 'Tu regalo ya está en el carrito. Es gratis con cualquier otra compra.' : 'Agrega tu regalo al carrito: es gratis con cualquier otra compra.');
    ui.resNota.textContent = notas.join(' ');
  }
  function copiarCodigo() {
    var r = memoria.res || resGuardado(); if (!r || !r.codigo) return;
    function listo() { ui.copiado.textContent = 'Código copiado'; }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(r.codigo).then(listo, seleccionar);
    else seleccionar();
    function seleccionar() { // sin portapapeles: deja el código seleccionado para copiarlo a mano
      try { var rg = document.createRange(); rg.selectNodeContents(ui.codTxt); var sel = getSelection(); sel.removeAllRanges(); sel.addRange(rg); } catch (e) { /* nada */ }
    }
  }

  /* ---------- Confeti (canvas, se borra a los 4 s; nunca con reducir movimiento) ---------- */
  function confeti() {
    if (reducir.matches) return;
    var c = document.createElement('canvas'), dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = window.innerWidth, H = window.innerHeight;
    c.className = 'ff-rl-confeti'; c.setAttribute('aria-hidden', 'true');
    c.width = W * dpr; c.height = H * dpr;
    document.body.appendChild(c);
    var x = c.getContext('2d'); if (!x) { c.remove(); return; }
    x.scale(dpr, dpr);
    var COL = ['#E02D1B', '#FFC400', '#16A34A', '#7C3AED', '#1E6FE0', '#E0218A', '#D7FF1F', '#ff8a00'];
    var P = [], n = W < 750 ? 140 : 220;
    for (var i = 0; i < n; i++) {
      var lado = i % 2 ? 1 : -1;
      P.push({ x: W / 2 + lado * (W * 0.1), y: H * 0.42, vx: lado * (2 + Math.random() * 9) + (Math.random() - 0.5) * 4, vy: -(6 + Math.random() * 12),
        r: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.4, w: 6 + Math.random() * 6, h: 4 + Math.random() * 8, c: COL[i % COL.length], f: i % 5 });
    }
    var t0 = performance.now();
    function cuadro(t) {
      var e = t - t0;
      x.clearRect(0, 0, W, H);
      if (e > 4000) { c.remove(); return; }
      x.globalAlpha = e > 3200 ? Math.max(0, (4000 - e) / 800) : 1;
      P.forEach(function (p) {
        p.vy += 0.32; p.vx *= 0.985; p.x += p.vx; p.y += p.vy; p.r += p.vr;
        x.save(); x.translate(p.x, p.y); x.rotate(p.r); x.fillStyle = p.c;
        if (p.f === 0) { x.beginPath(); x.arc(0, 0, p.w / 2, 0, 6.29); x.fill(); }
        else x.fillRect(-p.w / 2, -p.h / 2, p.w, p.h * Math.abs(Math.cos(p.r * 2)) + 1);
        x.restore();
      });
      requestAnimationFrame(cuadro);
    }
    requestAnimationFrame(cuadro);
  }

  /* ---------- Arranque ---------- */
  function iniciar() {
    if (iniciado) return;
    iniciado = true;
    var cache = null;
    try { cache = JSON.parse(leerS(S_ESTADO) || 'null'); } catch (e) { cache = null; }
    var pedido = cache && cache.j && Date.now() - cache.t >= 0 && Date.now() - cache.t < CACHE_GET_MS
      ? Promise.resolve(cache.j) // 5 min de caché por pestaña: menos llamadas al ERP al navegar
      : fetch(ERP, { method: 'GET', credentials: 'omit', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { if (j && j.ok) guardarS(S_ESTADO, JSON.stringify({ t: Date.now(), j: j })); return j; });
    pedido
      .then(function (j) {
        if (!j || !j.ok || !j.activa || !Array.isArray(j.sectores) || !j.sectores.length) return;
        estado = { sectores: j.sectores.filter(function (s) { return s && typeof s.id === 'number' && typeof s.etiqueta === 'string'; }).map(function (s) {
          return { id: s.id, etiqueta: s.etiqueta, color: /^#[0-9a-f]{3,8}$/i.test(s.color) ? s.color : '#E02D1B', texto: /^#[0-9a-f]{3,8}$/i.test(s.texto) ? s.texto : '#ffffff' };
        }) };
        if (!estado.sectores.length) return;
        construir();
        aplicarFase();
      })
      .catch(function () { /* sin ERP no hay ruleta: la tienda sigue igual */ });
  }
  function aplicarFase() {
    var dia = html.classList.contains('ff-fd-dia');
    if (!dia) {
      if (ui) { if (abierto) { girando = false; cerrarModal(); } ui.flot.hidden = true; raiz.hidden = true; }
      return;
    }
    if (!ui) { iniciar(); return; }
    raiz.hidden = false;
    if (memoria.apagada) { ui.flot.hidden = true; return; }
    if (!abierto) { textoFlotante(); ui.flot.hidden = false; }
    if (memoria.auto) return;
    memoria.auto = true;
    // Apertura sola: la 1.ª vez que entra (tras 1,5 s) y UNA vez más si vuelve tras 30 min sin haber girado.
    // Sin almacenamiento no se recuerda nada: se abre una vez por carga de página.
    var previo = resGuardado();
    if (previo) { // visitas siguientes: si el carrito perdió el código, se vuelve a aplicar UNA vez por sesión (el regalo solo una vez)
      memoria.res = previo;
      if (previo.codigo && !leerS(S_REAPLICADO)) { guardarS(S_REAPLICADO, '1'); aplicarEnCarrito(previo); }
      return;
    }
    var primera = Number(leer(K_ABIERTA)) || 0, reabrir = false;
    if (primera) {
      if (leer(K_REABIERTA) === '1' || Date.now() - primera < REABRIR_MS) return;
      reabrir = true;
    }
    setTimeout(function () {
      if (!html.classList.contains('ff-fd-dia') || resGuardado() || memoria.res || abierto) return;
      // La marca se guarda al abrir de verdad, no al programar.
      if (reabrir) guardar(K_REABIERTA, '1'); else guardar(K_ABIERTA, String(Date.now()));
      abrirModal();
    }, ESPERA_MS);
  }
  // Los botones «🎡 Girar la ruleta» de la decoración abren el popup (o «Tu premio» si ya giró).
  document.addEventListener('ff:ruleta-abrir', function () { if (ui && html.classList.contains('ff-fd-dia') && !memoria.apagada) abrirModal(); });
  new MutationObserver(aplicarFase).observe(html, { attributes: true, attributeFilter: ['class'] });
  aplicarFase();
})();
